import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import api from '../../Services/api';

import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Grid, MenuItem, Select, FormControl, InputLabel
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { MdFileOpen,MdEdit, MdRemoveRedEye, MdDelete, MdEditDocument } from "react-icons/md";




const currentYear = new Date().getFullYear();

const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);

const statesInIndia = [
  'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh',
  'Jharkhand','Karnataka', 'Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland',
  'Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal',
  'Andaman and Nicobar Islands','Chandigarh','Dadra and Nagar Haveli and Daman and Diu','Delhi','Ladakh','Lakshadweep','Puducherry'
];

export const ClientList = () => {
  const [clients, setClients] = useState([]);
  const [editingClient, setEditingClient] = useState(null);
  const[masterDataCreate,setMasterDataCreate]=useState(false)
  const [errors, setErrors] = useState({});
    const[corporate,setCorporate] = useState([]);
       const [originalClientData, setOriginalClientData] = useState(null);
  const [loading, setLoading] = useState(true);
            const [selectedYear, setSelectedYear] = useState(currentYear);
  
  const [clientFormData, setClientFormData] = useState({
    companyId: "",
    CorporateId:"",
    principleEmployer: "",
    stateId: "",
    placeName: "",
    pinCode:"",
    companyAddress: "",
    authorisedPersonName: "",
    companyPhoneNumber: "",
    companyEmailId: "",
    companyPhoneNumber1: "",
    companyEmailId1: "",
    clientName: "",
    clientAddress:'',
    division:'',
    clientContactPersonName: "",
    clientContactPersonPhoneNumber: "",
    clientContactPersonEmailId: "",
    clientContactPersonPhoneNumber1: "",
    clientContactPersonEmailId1: "",
    startDate: "",
    endDate: "",
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
const[clientName,setClientName] = useState('')

  const validateForm = () => {
    const newErrors = {};
    const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/;
    const phonePattern = /^[6789]\d{9}$/;
    const pinCodePattern = /^(?!000000$)[0-9]{6}$/;
    
    if (!clientFormData.principleEmployer) newErrors.principleEmployer = 'Company Name is required';
    if (!clientFormData.stateId) newErrors.stateId = 'State is required';
    if (!clientFormData.placeName) newErrors.placeName = 'Place is required';
    if (!clientFormData.companyAddress) newErrors.companyAddress = 'Address is required';
    if (!clientFormData.authorisedPersonName) newErrors.authorisedPersonName = 'Conatct Person name is required';
    if (!emailPattern.test(clientFormData.companyEmailId)) {
      newErrors.companyEmailId = clientFormData.companyEmailId ? 'Invalid email address(ex:text@email.com)' : 'Email address required';
    }
    if (clientFormData.companyEmailId1 && !emailPattern.test(clientFormData.companyEmailId1)) {
      newErrors.companyEmailId1 = 'Invalid email address (e.g., text@email.com)';
    }

   
    if(!pinCodePattern.test(clientFormData.pinCode)){
      newErrors.pinCode = clientFormData.pinCode ? 'Invalid Pin code format(245678)' : 'Pin code required';
    }
    if (!clientFormData.companyPhoneNumber) {
      newErrors.companyPhoneNumber = 'Phone number required';
    } else {
    
      const phonePattern = /^[6-9]\d{9}$/;
      if (!phonePattern.test(clientFormData.companyPhoneNumber)) {
        newErrors.companyPhoneNumber = 'Invalid phone number, Number should not start with zero(6-9)';
      }
      
      const phoneNumber = String(clientFormData.companyPhoneNumber);
      if (phoneNumber.length !== 10 || !/^\d{10}$/.test(phoneNumber)) {
        newErrors.companyPhoneNumber = 'Phone number should be exactly 10 digits';
      }
    }
    if (clientFormData.companyPhoneNumber1 && !phonePattern.test(clientFormData.companyPhoneNumber1)) {
      newErrors.companyPhoneNumber1 = 'Invalid phone number. Number should not start with zero(6-9) and length should be 10';
    }
   
    if (!clientFormData.clientName) newErrors.clientName = 'Establishment Name  is required';
    if (!clientFormData.clientAddress) newErrors.clientAddress = 'Establishment Address  is required';
    if (!clientFormData.division) newErrors.division = 'Division  is required';

    if (!clientFormData.clientContactPersonName) newErrors.clientContactPersonName = 'Contact Person Name is required';
    if (!emailPattern.test(clientFormData.clientContactPersonEmailId)) {
      newErrors.clientContactPersonEmailId = clientFormData.clientContactPersonEmailId ? 'Invalid email address(ex:text@email.com)' : 'Email address required';
    }
    if (clientFormData.clientContactPersonEmailId1 && !emailPattern.test(clientFormData.clientContactPersonEmailId1)) {
      newErrors.clientContactPersonEmailId1 = 'Invalid email address (e.g., text@email.com)';
    }
    if (!clientFormData.clientContactPersonPhoneNumber) {
      newErrors.clientContactPersonPhoneNumber = 'Phone number required';
    }else {
    
      const phonePattern = /^[6-9]\d{9}$/;
      if (!phonePattern.test(clientFormData.clientContactPersonPhoneNumber)) {
        newErrors.clientContactPersonPhoneNumber = 'Invalid phone number, Number should not start with zero(6-9)';
      }
      
      const phoneNumber = String(clientFormData.clientContactPersonPhoneNumber);
      if (phoneNumber.length !== 10 || !/^\d{10}$/.test(phoneNumber)) {
        newErrors.clientContactPersonPhoneNumber = 'Phone number should be exactly 10 digits';
      }
    }
    if (clientFormData.clientContactPersonPhoneNumber1 && !phonePattern.test(clientFormData.clientContactPersonPhoneNumber1)) {
      newErrors.clientContactPersonPhoneNumber1 = 'Invalid phone number. Number should not start with zero(6-9) and length should be 10)';
    }
  
    if (!clientFormData.startDate) newErrors.startDate = 'Contract Start Date is required';
    if (!clientFormData.endDate) newErrors.endDate = 'Contract End Date is required';

    const selectField = clientFormData.stateId;
    if (!selectField) {
      newErrors.selectField = 'Please select State';
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const fetchClients = async () => {
    try {
      const response = await api.client.getClients();
      setClients(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching clients:', error);
      setLoading(false);
    }
  };

  const handleEditClick = (client) => {
    setEditingClient(client.companyId);
    setClientFormData({ ...client });
    setOriginalClientData({...client})

  };
    const handleCreateMasterDataClick = (client) => {
     sessionStorage.setItem("clientId",client.companyId)
          sessionStorage.setItem("corporateId",client.CorporateId)
          setClientName(client.clientName);
          handleCreateMasterData()
         
          // sessionStorage.setItem("companyName",client.clientName)

  };

   const handleDeleteMasterDataClick = (client) => {
     sessionStorage.setItem("clientId",client.companyId)
          sessionStorage.setItem("corporateId",client.CorporateId)
          setClientName(client.clientName);
          handleDeleteMasterData()
         
          // sessionStorage.setItem("companyName",client.clientName)

  }; 
  const handleDeleteMasterData = async()=>{
const id = sessionStorage.getItem("clientId")
    const id2 = sessionStorage.getItem("corporateId")
     const confirm = window.confirm(
    `Are you sure you want to Delete master data ?`
  );
      if (!confirm) {
  
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage("Master data deletion cancelled. Please select year again.");
    return;


      }
 try{
    const response = await api.client.deleteMasterData(id) 
      if(response.status === 200){
       
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message)
        // setMasterDataCreate(false)
        sessionStorage.removeItem("clientId")
        sessionStorage.removeItem("corporateId")
       
      }
      else if(response.status === 404){
        
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
      }
       else if(response.status === 400){
        
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
      }
       else if(response.status === 500){
        
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
        setMasterDataCreate(false)
      }
      else{
       
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Some error occured,try again");
      
      }
    
    }
      catch(error) {
        console.error('Error saving company master data:', error);
      
        
      }
  

  };
  const handleCreateMasterData = async()=>{
   const id = sessionStorage.getItem("clientId")
    const id2 = sessionStorage.getItem("corporateId")
 
   const confirm = window.confirm(
    `Are you sure you want to create master data ?`
  );

  if (!confirm) {
  
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage("Master data creation cancelled. Please select year again.");
    return;
  }
    const masterData = {
      companyId: id,
      year: selectedYear,
      CorporateId:id2,
      AcceptedPercent: 0,
      RejectedPercent: 0,
      UnderReviewPercent: 0,
      complied : 0,
      nonComplied : 0,

      POCopyNumber: {
        value: '',
   
      },
      EPFOAllotmentCopy: {
        value: '',
    
      },
      ESICAllotmentCopy: {
        value: '',
      
      },
      PTaxRCNumber: {
        value: '',
     
      },
      PTECNumber: {
        value: '',
     
      },
      LWFNumber: {
        value: '',
     
      },
      FactoryLicence: {
        value: '',
      
      },
      BuildingPlanLayout: {
        value: '',
     
      },
      StabilityCertificate: {
        value: '',
     
      },
      ConcernToEstablishment: {
        value: '',
    
      },
      ConcernToOperations: {
        value: '',
   
      },
      FireAdvisory: {
        value: '',
    
      },
      FireNOC: {
        value: '',
    
      },
      EnvironmentClearance: {
        value: '',
      
      },
      MedicalHospitalCertificate: {
        value: '',
       
      },
      ApprenticeshipRegistration: {
        value: '',
    
      },
      NEEMNAPSRegistration: {
        value: '',
    
      },
      CLRARC: {
        value: '',
   
      },
      SandCERC: {
        value: '',
    
      },
      BOCWRC: {
        value: '',
      
      },
      ISMWRC: {
        value: '',
     
      },
      PSARALicence: {
        value: '',
      
      },
      FSSAILicence: {
        value: '',
      
      },
      WCPolicyNumber: {
        value: '',
      
      },
      GSTCertificate: {
        value: '',
      
      },
       ManagerChange: {
        value: '',
      
      },
       ShiftApproval: {
        value: '',
      
      },
       HazardouswasteDisposalApproval: {
        value: '',
      
      },
       BoilerAmendment: {
        value: '',
      
      },
       BiomedicalWasteApproval: {
        value: '',
      
      },
       AnalysisFeePayment: {
        value: '',
      
      },
       ComplianceCertificate: {
        value: '',
      
      },
       StandingOrder: {
        value: '',
      
      },
       TradeLicenceRegAndRenewal: {
        value: '',
      
      },




    }

 try{
    const response = await api.client.createClientMasterData(masterData) 
      if(response.status === 201){
       
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message)
        setMasterDataCreate(false)
        sessionStorage.removeItem("clientId")
        sessionStorage.removeItem("corporateId")
       
      }
      else if(response.status === 400){
        
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
      }
       else if(response.status === 500){
        
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
        setMasterDataCreate(false)
      }
      else{
       
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Some error occured,try again");
      
      }
    
    }
      catch(error) {
        console.error('Error saving company master data:', error);
      
        
      }
  
  }
  const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
       
    };
    
  useEffect(()=>{
    api.Corporate.getCorporate()
    .then(response => {
      setCorporate(response.data.data)
    })
    .catch(error => {
      console.error(`Error fetching Corporate Names`,error)
    })
    },[])

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setClientFormData({ ...clientFormData, [name]: value });
  };

  const handleSave = async () => {
    const isDataChanged = JSON.stringify(clientFormData) !== JSON.stringify(originalClientData);

    if (!isDataChanged) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("No changes detected");
      setEditingClient();
      return; 
    }
    if(validateForm()){
    try {
      const response = await api.client.editClient(clientFormData.companyId, clientFormData);
      if (response.status === 200) {
       
        setSnackbarOpen(true);
        setSnackbarMessage("Updated successfully!")
        setEditingClient(null);
        fetchClients();
      } else {
        
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Error in submitting");

      }
    } catch (error) {
      console.error('Error saving data:', error);
     
    }
  }
  };

  const handleCancel = () => {
    setEditingClient(null);
    setErrors({})
  };
  const handleMasterDataDialogClose = () => {
  setMasterDataCreate(false)
  };

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <>
     <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          
          }}
          severity="success"
          open={snackbarOpen}
          autoHideDuration={2000}
          onClose={() => setSnackbarOpen(false)}
          sx={{
            marginTop: '2.9%', 
            marginRight: '7%'
          }}
        >
          <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          severity="error"
          open={errorSnackbarOpen}
          autoHideDuration={2000}
          sx={{
            marginTop: '2.9%', 
            marginRight: '7%'
          }}
          onClose={() => {setErrorSnackbarOpen(false)}}
        >
          <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
        </Snackbar>
        {loading ? (
           <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
           <h3>Loading</h3>
  <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
  <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
  <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
  
  </div>
        ) : 
    clients && clients.length > 0 ? (
    <div className="m-4">
      <h5>Establishment List <i class="bi bi-arrow-right-square-fill" ></i></h5>
     
        <TableContainer>
          <div style={{ minHeight:"420px",maxHeight: "440px", marginTop:"10px", overflowY: "auto" }}>
          <Table style={{  width: '100%',borderTop:'none' }}>
            <TableHead className="position-sticky top-0 " style={{zIndex:1000, backgroundColor: 'black', color: 'white', fontWeight: 'bold',borderTop:"none" }}>
              <TableRow style={{backgroundColor:'black',color:'white'}}>
                <th className='border-top-0'>Principal Employer Details</th>
                <th className='border-top-0'>Establishment Details</th>
                <th className='border-top-0'>Action</th>
              </TableRow>
            </TableHead>
            <TableBody>
              {clients.map((client) => (
                <TableRow key={client.companyId}>
                  <TableCell>
                  <div style={{fontSize:"14px",fontWeight:'bold'}}>{client.principleEmployer}</div>
                
                    <div style={{color:'gray'}} >Address : {client.companyAddress}, {client.placeName} {client.stateId}- {client.pinCode}</div>
                    
                    <div style={{color:'gray'}} >Contact Person : {client.authorisedPersonName}</div>
                    <div style={{color:'gray'}} >Contact Number : {client.companyPhoneNumber} {client.companyPhoneNumber1 && `, ${client.companyPhoneNumber1}`}</div>
                    <div style={{color:'gray'}} >Email : {client.companyEmailId} {client.companyEmailId1 && `, ${client.companyEmailId1}`}</div>
                  </TableCell>
                  <TableCell>
                    <div style={{fontSize:"14px",fontWeight:'bold'}}>{client.clientName}</div>
                    <div style={{color:'gray'}} >Contact Person : {client.clientContactPersonName}</div>
                    <div style={{color:'gray'}} >Contact Number : {client.clientContactPersonPhoneNumber} {client.clientContactPersonPhoneNumber1 && `, ${client.clientContactPersonPhoneNumber1}`}</div>
                    <div style={{color:'gray'}} >Email : {client.clientContactPersonEmailId} {client.clientContactPersonEmailId1 && `, ${client.clientContactPersonEmailId1}`}</div>
                    <div style={{color:'gray'}} >Contract Start Date : {client.startDate?.slice(0,10).split('-').reverse().join('-')}</div>
                    <div style={{color:'gray'}} >Contract End Date : {client.endDate?.slice(0,10).split('-').reverse().join('-')}</div>
                  </TableCell>
                  <TableCell>
                    <div className="d-flex justify-content-between gap-2">
                  <button className="px-1 py-1 border-1 border-blue-600 rounded"  title="Edit" onClick={() => handleEditClick(client)}>
                     <MdEditDocument className="text-lg text-blue-600" />
                  </button>
                   <button className="btn btn-outline-success btn-sm" title="Create Masterdata" onClick={() => handleCreateMasterDataClick(client)}>
                         Create
                  </button>
                     <button className="btn btn-outline-danger btn-sm" title="Delete Masterdata" onClick={() => handleDeleteMasterDataClick(client)}>
                         Delete
                  </button>
                  </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </div>
        </TableContainer>
        </div>
    ) : (
      <div className='mt-4'>
        <p className="text-center">No Clients Found !! <Link to="/createcompany" className='text-danger'>Click here</Link> to Create</p>
      </div>
    )}

      {/* Edit Dialog Popup */}
      <Dialog open={editingClient !== null} onClose={handleCancel} fullWidth maxWidth="md">
      <h6 style={{textAlign:'center',color:'white',backgroundColor:"#1C1C1C",padding:'24px',letterSpacing:'0.5px'}}>EDIT ESTABLISHMENT DETAILS</h6>
     
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
               <InputLabel>Select Corporate</InputLabel>
            <Select
            className="w-100"
                      label="Select Corporate"
                      value={clientFormData.CorporateId}
                      onChange={handleFormChange}
                      InputLabelProps={{ shrink: true }}
                      name="CorporateId"
                      displayEmpty
                      // error={!!errors.CorporateId}
                    >
                    
                      {Array.isArray(corporate) && corporate.map((corporate, index) => (
                        <MenuItem key={index} value={corporate.CorporateId}>{corporate.CorporateName}, {corporate.CorporateState}</MenuItem>
                      ))}
                    </Select>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Principal Employer"
                name="principleEmployer"
                value={clientFormData.principleEmployer}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.principleEmployer}
                helperText={errors.principleEmployer}
              />
              <FormControl fullWidth>
                       <InputLabel id="demo-simple-select-label">Select State</InputLabel>
                <Select
                  name="stateId"
                     label="Select State"
                  value={clientFormData.stateId}
                  onChange={handleFormChange}
                  error={!!errors.stateId}
                >
                  {statesInIndia.map((state, index) => (
                    <MenuItem key={index} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.selectField && (
            <div className="pb-3 px-5" style={{ color: 'red', fontSize: '14px' }}>
              {errors.selectField}
            </div>
          )}
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Company Address"
                name="companyAddress"
                value={clientFormData.companyAddress}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.companyAddress}
                helperText={errors.companyAddress}
              />
              <TextField
                fullWidth
                label="Place / City"
                name="placeName"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.placeName}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.placeName}
                helperText={errors.placeName}
              />
              <TextField
                fullWidth
                label="Pin Code"
                name="pinCode"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.pinCode}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.pinCode}
                helperText={errors.pinCode}
              />
              <TextField
                fullWidth
                label="Authorised Person Name"
                name="authorisedPersonName"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.authorisedPersonName}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.authorisedPersonName}
              helperText={errors.authorisedPersonName}
              />
              <TextField
                fullWidth
                label="Email"
                name="companyEmailId"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.companyEmailId}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.companyEmailId}
              helperText={errors.companyEmailId}
              />
             
              <TextField
                fullWidth
                label="Alternative Email"
                name="companyEmailId1"
                InputLabelProps={{ shrink: true }}
                type="email"
                value={clientFormData.companyEmailId1}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.companyEmailId1}
              helperText={errors.companyEmailId1}
              />
            
              <TextField
                fullWidth
                label="Contact Number"
                name="companyPhoneNumber"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.companyPhoneNumber}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.companyPhoneNumber}
              helperText={errors.companyPhoneNumber}
              />
             
               <TextField
                fullWidth
                label="Alternative Contact Number"
                name="companyPhoneNumber1"
                InputLabelProps={{ shrink: true }}
              
                value={clientFormData.companyPhoneNumber1}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.companyPhoneNumber1}
              helperText={errors.companyPhoneNumber1}
              />
              
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Establishment / Company Name"
                name="clientName"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.clientName}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.clientName}
              helperText={errors.clientName}
              />
               <TextField
                fullWidth
                label="Address"
                name="clientAddress"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.clientAddress}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.clientAddress}
              helperText={errors.clientAddress}
              />
               <TextField
                fullWidth
                label="Division"
                name="division"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.division}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.division}
              helperText={errors.division}
              />
              <TextField
                fullWidth
                label="Establishment Contact Person"
                name="clientContactPersonName"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.clientContactPersonName}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.clientContactPersonName}
              helperText={errors.clientContactPersonName}
              />
         
              <TextField
                fullWidth
                label="Email"
                name="clientContactPersonEmailId"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.clientContactPersonEmailId}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.clientContactPersonEmailId}
              helperText={errors.clientContactPersonEmailId}
              />
        
        
               <TextField
                fullWidth
                label="Alternative Email"
                name="clientContactPersonEmailId1"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.clientContactPersonEmailId1}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.clientContactPersonEmailId1}
              helperText={errors.clientContactPersonEmailId1}
              />
        
              <TextField
                fullWidth
                label="Contact Number"
                name="clientContactPersonPhoneNumber"
                value={clientFormData.clientContactPersonPhoneNumber}
                onChange={handleFormChange}
                InputLabelProps={{ shrink: true }}
                margin="normal"
                error={!!errors.clientContactPersonPhoneNumber}
              helperText={errors.clientContactPersonPhoneNumber}
              />
              
               <TextField
                fullWidth
                label="Alternative Contact Number"
                name="clientContactPersonPhoneNumber1"
                value={clientFormData.clientContactPersonPhoneNumber1}
                onChange={handleFormChange}
                InputLabelProps={{ shrink: true }}
                margin="normal"
                error={!!errors.clientContactPersonPhoneNumber1}
              helperText={errors.clientContactPersonPhoneNumber1}
              />
            
              <TextField
                fullWidth
                type="date"
                label="Contract Start Date"
                name="startDate"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.startDate ? clientFormData.startDate.slice(0, 10) : ''}
                onChange={handleFormChange}
                margin="normal"
                InputProps={{
                  inputProps: {
                    max: clientFormData.endDate, // Dynamically set the min date
                  },
                }}
                error={!!errors.startDate}
              helperText={errors.startDate}
              />
              <TextField
                fullWidth
                type="date"
                label="Contract End Date"
                name="endDate"
                InputLabelProps={{ shrink: true }}
                value={clientFormData.endDate ? clientFormData.endDate.slice(0, 10) : ''}
                onChange={handleFormChange}
                margin="normal"
                error={!!errors.endDate}
              helperText={errors.endDate}
              InputProps={{
                inputProps: {
                  min: clientFormData.startDate, // Dynamically set the min date
                },
              }}
              />
            </Grid>
          </Grid>
        </DialogContent>
       
        <div className='mx-4 mb-3' style={{display:'flex',justifyContent:'space-between'}}>
          <button className="btn btn-md btn-outline-secondary" onClick={handleCancel} >
            Cancel
          </button>
          <button className="btn btn-md btn-success" onClick={handleSave} disabled={!validateForm} >
            Save
          </button>
          </div>
      
      </Dialog>

     {/* <Dialog maxWidth="md" open={masterDataCreate} onClose={handleMasterDataDialogClose}>
      <h6 style={{textAlign:'center',color:'white',backgroundColor:"#1C1C1C",padding:'24px',letterSpacing:'0.5px'}}>CREATE MASTERDATA</h6>
  
 <p className="text-center p-3"><span className='font-bold'>Selected Establishment:</span><br></br>{clientName}</p>
  <DialogContent>
  <div className="flex justify-center mb-2">
      <select
        className="p-2 border-1 border-gray-400 rounded cursor-pointer"
        value={selectedYear || ''}
        onChange={handleYearChange}
      >
        <option value="" disabled>Select Year</option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>

    <div className="flex justify-between mt-4">
      <button
        className="btn btn-sm btn-outline-secondary"
        onClick={handleMasterDataDialogClose}
      >
        Cancel
      </button>

      <button
        className="btn btn-sm btn-success"
        onClick={handleCreateMasterData}
        disabled={!selectedYear} // optional: disable if year not selected
      >
        Create
      </button>
    </div>
  </DialogContent>
</Dialog> */}

   
    </>
  );
};
